import React from "react";
import { api } from "../lib/api";

export class ErrorBoundary extends React.Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) {
    try { api.post("/errors/report", { message: String(error?.message || error), stack: (info?.componentStack || "").slice(0, 4000), page: window.location.pathname }); } catch {}
    if (window.Sentry) window.Sentry.captureException(error);
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f6f7f4] p-6" data-testid="error-boundary">
        <div className="max-w-md text-center">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-2">Playmaker</div>
          <h1 className="text-2xl font-semibold tracking-tight">Er ging iets mis / Something went wrong</h1>
          <p className="text-sm text-slate-500 mt-2">De fout is automatisch gemeld. Herlaad de pagina of ga terug naar het overzicht. / The error has been reported automatically.</p>
          <div className="flex gap-2 justify-center mt-5">
            <button onClick={() => window.location.reload()} className="h-10 px-4 rounded-xl bg-slate-900 text-white text-sm font-semibold" data-testid="error-reload">Herladen</button>
            <a href="/" className="h-10 px-4 rounded-xl border border-slate-300 text-sm font-semibold flex items-center" data-testid="error-home">Naar overzicht</a>
          </div>
        </div>
      </div>
    );
  }
}
